import React, { useState } from 'react';

const Partnership = () => {
  const [openAccordion, setOpenAccordion] = useState(0);

  const toggleAccordion = (index) => {
    if (openAccordion === index) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(index);
    }
  };

  return (
    <>
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
        Partner with <span className="text-primary-700">BildUp</span>
      </h1>

      <div className="grid md:grid-cols-3 gap-8 mb-16">
        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow text-center hover:border-primary-300 transition-colors">
          <h5 className="text-xl font-bold text-primary-700 mb-2">
            Educational Institutions
          </h5>
          <p className="text-gray-700 mb-4">
            Enhance your curriculum with our AI-powered learning platform.
          </p>
          <button className="text-white bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5">
            Learn More
          </button>
        </div>

        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow text-center hover:border-primary-300 transition-colors">
          <h5 className="text-xl font-bold text-primary-700 mb-2">
            Content Creators
          </h5>
          <p className="text-gray-700 mb-4">
            Share your expertise and reach a global audience of learners.
          </p>
          <button className="text-white bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5">
            Join Us
          </button>
        </div>

        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow text-center hover:border-primary-300 transition-colors">
          <h5 className="text-xl font-bold text-primary-700 mb-2">
            Technology Partners
          </h5>
          <p className="text-gray-700 mb-4">
            Integrate your solutions with our platform for enhanced learning experiences.
          </p>
          <button className="text-white bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5">
            Partner Up
          </button>
        </div>
      </div>

      <div className="p-6 bg-white border border-gray-200 rounded-lg shadow mb-16 hover:border-primary-300 transition-colors">
        <h2 className="text-2xl font-bold text-primary-700 mb-4">
          Partnership Benefits
        </h2>
        <div className="space-y-2">
          <div className="border border-gray-200 rounded-t-lg">
            <button 
              className={`flex items-center justify-between w-full p-5 font-medium rtl:text-right ${openAccordion === 0 ? 'text-primary-700 bg-primary-50' : 'text-gray-500 bg-white'}`}
              onClick={() => toggleAccordion(0)}
            >
              <span>Revenue Sharing</span>
              <svg 
                className={`w-3 h-3 rotate-180 shrink-0 ${openAccordion === 0 ? 'transform rotate-0' : ''}`} 
                aria-hidden="true" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 10 6"
              >
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
              </svg>
            </button>
            <div className={`${openAccordion === 0 ? 'block' : 'hidden'} p-5 border-t border-gray-200`}>
              <p className="text-gray-700">
                Benefit from our competitive revenue sharing model and grow your business with us.
              </p>
            </div>
          </div>
          <div className="border border-gray-200">
            <button 
              className={`flex items-center justify-between w-full p-5 font-medium rtl:text-right ${openAccordion === 1 ? 'text-primary-700 bg-primary-50' : 'text-gray-500 bg-white'}`}
              onClick={() => toggleAccordion(1)}
            >
              <span>Technical Support</span>
              <svg 
                className={`w-3 h-3 rotate-180 shrink-0 ${openAccordion === 1 ? 'transform rotate-0' : ''}`} 
                aria-hidden="true" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 10 6"
              >
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
              </svg>
            </button>
            <div className={`${openAccordion === 1 ? 'block' : 'hidden'} p-5 border-t border-gray-200`}>
              <p className="text-gray-700">
                Get dedicated technical support and integration assistance from our team.
              </p>
            </div>
          </div>
          <div className="border border-gray-200 rounded-b-lg">
            <button 
              className={`flex items-center justify-between w-full p-5 font-medium rtl:text-right ${openAccordion === 2 ? 'text-primary-700 bg-primary-50' : 'text-gray-500 bg-white'}`}
              onClick={() => toggleAccordion(2)}
            >
              <span>Marketing Opportunities</span>
              <svg 
                className={`w-3 h-3 rotate-180 shrink-0 ${openAccordion === 2 ? 'transform rotate-0' : ''}`} 
                aria-hidden="true" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 10 6"
              >
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
              </svg>
            </button>
            <div className={`${openAccordion === 2 ? 'block' : 'hidden'} p-5 border-t border-gray-200`}>
              <p className="text-gray-700">
                Access joint marketing opportunities and reach our growing user base.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Partnership; 